<template>
  <div class="page-content">
    <div class="tle-row part">
    <div class="tle-col one-third">
      <table-surface-loyer/>
    </div>
    <div class="tle-col two-third self-end">
      <div :class="{'tle-row' : true , 'margin-edition': editor.mode == 'editing'}">
        <div class="tle-col one-third">
          <el-image
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
                .pictures.images[0]
            "
            property="src"
            :editable="true"
            max_height="90px"
            edition_position="top"
          />
          <el-textarea
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
                .pictures
            "
            property="titre_photo1"
            :editable="true"
            class="text-center text-italic image-description"
          />
        </div>
        <div class="tle-col one-third">
          <el-image
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
                .pictures.images[1]
            "
            property="src"
            :editable="true"
            max_height="90px"
            edition_position="top"
          />
          <el-textarea
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
                .pictures
            "
            property="titre_photo2"
            :editable="true"
            class="text-center text-italic image-description"
          />
        </div>
        <div class="tle-col one-third">
          <el-image
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
                .pictures.images[2]
            "
            property="src"
            :editable="true"
            max_height="90px"
            edition_position="top"
          />
          <el-textarea
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
                .pictures
            "
            property="titre_photo3"
            :editable="true"
            class="text-center text-italic image-description"
          />
        </div>
      </div>
      <div class="q-mt-sm">
        <p>Niveau d’attractivité de la résidence</p>
        <el-progress-slider
          :parent_data="
            active_study.etudeData.gie.sectionCaracteristiquesResidence
          "
          property="attractivite_residence"
          :max="10"
          :editable="true"
          :labels="['Faible', 'Élevé']"
          style="margin-bottom: 0"
        />
      </div>
    </div>
  </div>

  <div class="tle-row">
    <div class="tle-col half-little">
      <p class="label main_color_text">Caractéristiques de la résidence</p>
      <div
        class="el-closed-question dense"
        :class="{ 'can-change': editor.mode == 'editing' }"
      >
        <div class="question-label">
          <div>Epoque de construction</div>
        </div>
        <span class="question-value">
          <el-textarea
            :parent_data="
              active_study.etudeData.gie.sectionCaracteristiquesResidence
            "
            property="epoque_construction"
            :editable="true"
          />
        </span>
      </div>
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="presence_gardien"
        :editable="true"
        label="Présence d’un gardien"
        :allowNC="true"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="portail_securise"
        :editable="true"
        label="Portail sécurisé"
        :allowNC="true"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="entree_securisee"
        :editable="true"
        label="Entrée sécurisée"
        :allowNC="true"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="etat_parties_communes_ext"
        :editable="true"
        label="État des parties communes extérieures"
        :options="['Très bon', 'Bon', 'Moyen', 'Mauvais', 'NC']"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="etat_parties_communes_int"
        :editable="true"
        label="État des parties communes intérieures"
        :options="['Très bon', 'Bon', 'Moyen', 'Mauvais', 'NC']"
        :dense="true"
      />
    </div>
    <div class="tle-col half-big">
      <p class="label main_color_text">
        Caractéristiques des logements visités
      </p>
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="taille_surface_habitable"
        :editable="true"
        label="Taille des surfaces habitables"
        :options="['Compactes', 'Standard', 'Spacieuses', 'NC']"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="taille_surface_exterieure"
        :editable="true"
        label="Taille des surfaces extérieures"
        :options="['Compactes', 'Standard', 'Spacieuses', 'NC']"
        :dense="true"
      />
      <div class="tle-row">
        <div class="tle-col half pd-tiny-right">
          <el-closed-question
            :parent_data="
            active_study.etudeData.gie.sectionCaracteristiquesResidence
            "
            property="mode_chauffage"
            :editable="true"
            label="Mode de chauffage"
            :options="['Individuel', 'Collectif', 'NC']"
            :dense="true"
          />
        </div>
         <div class="tle-col half pd-tiny-left">
            <el-closed-question
              :parent_data="
                active_study.etudeData.gie.sectionCaracteristiquesResidence
              "
              property="energie_utilise"
              :editable="true"
              label="Energie utilisée"
              :options="['Gaz', 'Électrique', 'Autre', 'NC']"
              :dense="true"
            />
        </div>
      </div>

      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="menuiserie"
        :editable="true"
        label="Menuiserie"
        :options="['Bois', 'Aluminium', 'PVC', 'NC']"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="cave"
        :editable="true"
        label="Cave"
        :allowNC="true"
        :dense="true"
      />
      <el-closed-question
        :parent_data="
          active_study.etudeData.gie.sectionCaracteristiquesResidence
        "
        property="parking"
        :editable="true"
        label="parking"
        :options="['Aucun', 'Extérieur', 'Couvert', 'Intérieur', 'Box', 'NC']"
        :dense="true"
      />
    </div>
  </div>
  </div>
</template>
  

<script>
import { mapGetters } from "vuex";

import number from "@/libs/number";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import getParameter from "@/libs/get_parameter.js";
import tableSurfaceLoyer from "@/components/study/editor/elements/data/table/table-surface-loyer";

export default {
	components: {
		tableSurfaceLoyer
	},
	name: "section-caracteristique-standing-classique",
	mixins: [PageMixin],
	data: function () {
		return {
			form: {},
			themePromo: "dynamique_marche_residentiel_promotion"
		};
	},
	props: ["index"],
	computed: {
		...mapGetters([
			"active_study",
			"editor",
			"etude_data"
		]),
		surface_loyer_table_lines: {
			get () {
				return parseInt(
					this.active_study.etudeData.gie.sectionCaracteristiquesResidence
						.surface_loyer_table_lines
				);
			},
			set (value) {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.gie.sectionCaracteristiquesResidence,
					field: "surface_loyer_table_lines",
					value: value,
				});
			}
    
		},
		surface_loyer_table () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [15, 25, 25, 30],
				},
			};

			table.head.push(["Type", "Nb.", "Surf. hab.", "Loyer/m²"]);

			for (let i = 0; i < this.surface_loyer_table_lines; i++) {
				const loc = this.active_study.etudeData.gie.sectionCaracteristiquesResidence.surface_loyer_table[i];
				const loyer_m2 = loc.loyer_m2;

				const rows = [
					{ parent_data: loc, property: "type", editable: true },
					{ parent_data: loc, property: "nb", editable: true },
					{
						parent_data: loc,
						property: "surf_hab",
						editable: true,
						suffix: " m²",
					},
				];

				if (i == 0) {
					rows.push({
						value: number.format(loyer_m2, 1),
						parent_data:
            this.active_study.etudeData.gie.sectionCaracteristiquesResidence,
						property: "surface_loyer_loyer_m2",
						editable: true,
						suffix: " €",
						rowspan: this.surface_loyer_table_lines + 1,
					});
				}

				table.body.push(rows);
			}

			const total = { type: 0, nb: 0, surf_hab: 0, loyer_m2: 0 };
			for (let i = 0; i < this.surface_loyer_table_lines; i++) {
				const loc = this.active_study.etudeData.gie.sectionCaracteristiquesResidence.surface_loyer_table[i];
				const nb = number.clean(loc.nb);

				if (nb) {
					total.nb += number.clean(nb);
					total.surf_hab += number.clean(loc.surf_hab) * number.clean(nb);
					total.loyer_m2 += number.clean(loc.loyer_m2) * number.clean(nb);
				}
			}

			table.body.push([
				"Total/Moy.",
				total.nb,
				{ value: number.format(total.surf_hab / total.nb, 1), suffix: "m²" },
			]);

			return table;
		},
		parameters () {
			return this.active_study.qlikData.parameters.editmode.find((editmode) => {
				return editmode.theme == this.themePromo;
			});
		},
		last_year_period () {
			return this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code);
		},
		last_year_periodTitle () {
      try{
        const currentPeriod = this.parameters.periods.values.find((value) => {
          return value.code == this.last_year_period;
        });
        return currentPeriod.title;
      }catch(e){
        return "Marché de la promotion immobilière :";
      }
		},
	},
	methods: {
		getParameter (name, defaultValue) {
			return getParameter(this.etude_data, this.themePromo, name, defaultValue);
		}
	},

};

</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app';
@import '../../../../../assets/css/page';

.margin-edition{
margin-top:15px
}

.pd-tiny-left{
padding-left: 2px;
}
.pd-tiny-right{
padding-right: 2px;
}
</style>
